<template>
    <b-card>
        <b-card-body>
            <b-form @submit.stop.prevent="onSubmit">
                <b-form-group
                    id="name-group"
                    label="Name*"
                    label-for="input-name"
                >
                    <b-form-input
                        type="text"
                        id="input-name"
                        v-model="model.name"
                        required
                        placeholder="Enter Name"
                        trim
                    ></b-form-input>
                </b-form-group>

                <b-form-group
                    id="description-group"
                    label="Description"
                    label-for="input-description"
                >
                    <b-form-input
                        type="text"
                        id="input-description"
                        v-model="model.description"
                        placeholder="Enter Description"
                        trim
                    ></b-form-input>
                </b-form-group>
                <b-button
                    variant="secondary"
                    :disabled="loading ? true : false"
                    @click="cancel()"
                    >Cancel</b-button
                >
                <b-button
                    v-if="hasPermissionUpdate"
                    type="submit"
                    variant="primary"
                    :disabled="loading ? true : false"
                    >{{ submitLabel }}</b-button
                >
                <b-button
                    v-if="model.id"
                    v-show="hasPermissionDelete"
                    @click="deleteAssetType()"
                    variant="warning"
                >
                    Delete Asset Type
                </b-button>
            </b-form>
        </b-card-body>
    </b-card>
</template>
<script>
import permissionsMixins from '@/mixins/permissionsMixins'
import errorHandlingMixins from '@/mixins/errorHandlingMixins'

export default {
    name: 'AssetTypes-viewItem',
    mixins: [permissionsMixins, errorHandlingMixins],
    data() {
        return {
            title: 'Asset Type',
            loading: false,
            model: {
                id: 0,
                name: null,
                description: null,
            },
            updating: false,
            submitting: false,
            hasErrors: false,
        }
    },
    props: ['item'],
    computed: {
        submitLabel() {
            if (this.loading && this.model.id) {
                return 'Updating...'
            } else if (this.loading) {
                return 'Creating...'
            } else if (this.model.id) {
                return 'Update'
            } else {
                return 'Create'
            }
        },
    },
    watch: {},
    mounted() {
        if (this.item.id) this.model = this.item
    },
    methods: {
        cancel() {
            this.$emit('cancel')
        },
        onSubmit() {
            this.loading = true
            const model = { ...this.model }
            console.log('model', model)
            const path = model.id ? 'assets/updateType' : 'assets/createType'
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.loading = true
                    this.$store
                        .dispatch(path, model)
                        .then(() => {
                            this.loading = false
                            const action = model.id ? 'Updated' : 'Created'
                            this.$emit('success', action, model.name)
                        })
                        .catch(error => {
                            console.error('Item Type Submit Error', error)
                            this.$emit('error', error, model.name)
                        })
                        .finally(() => {
                            this.loading = false
                        })
                } else {
                    this.loading = false
                }
            })
        },

        deleteAssetType() {
            // Initializing key variables
            console.log('Attempt to delete')
            const model = { ...this.model }
            const path = 'assets/deleteType'

            // Generate and display confirmation prompt
            const title = 'Delete Asset Type?'
            const message = `Are you sure you want to delete ${model.name}?`
            const errorMsg = 'Unable to delete Asset Type!'

            this.$emit(
                'delete-item',
                message,
                title,
                model.id,
                () => {
                    this.$emit('success', 'Deleted', model.name)
                },
                path,
                errorMsg
            )
        },
    },
}
</script>
<style></style>
